import { Outlet, useLocation } from 'react-router-dom';

export function AuthLayout() {
  const isRegister = useLocation().pathname.includes('/register');

  return (
    <div className="min-h-full gradient-bg">
      <div className="mx-auto flex min-h-full max-w-md flex-col justify-center px-6 py-12">
        <div className="mb-8 text-center">
          <h1 className="text-2xl font-semibold">SCUBE Agentic AI</h1>
          <p className="mt-2 text-secondary">
            {isRegister ? 'Create your business account' : 'Sign in to continue'}
          </p>
        </div>
        <div className="card-surface p-6">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
